import { ConfigProvider, App as AntApp } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProvidersPage from './pages/ProvidersPage';
import ProviderDetailPage from './pages/ProviderDetailPage';
import ModelGroupsPage from './pages/ModelGroupsPage';
import WorkflowsPage from './pages/WorkflowsPage';
import WorkflowEditorPage from './pages/WorkflowEditorPage';
import CategoriesPage from './pages/CategoriesPage';
import WorkersPage from './pages/WorkersPage';
import QueuePage from './pages/QueuePage';
import JobsPage from './pages/JobsPage';
import WebhooksPage from './pages/WebhooksPage';
import ConsumersPage from './pages/ConsumersPage';
import LogsPage from './pages/LogsPage';
import SettingsPage from './pages/SettingsPage';

dayjs.locale('vi');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: {
          colorPrimary: '#2563eb',
          colorInfo: '#2563eb',
          borderRadius: 10,
          colorBgLayout: '#f3f5fb',
          fontSize: 14,
        },
        components: {
          Card: { borderRadiusLG: 16 },
          Layout: { siderBg: 'transparent', headerBg: '#ffffff', bodyBg: '#f3f5fb' },
          Menu: {
            darkItemBg: 'transparent',
            darkSubMenuItemBg: 'transparent',
            darkItemSelectedBg: '#2563eb',
            darkItemColor: 'rgba(255,255,255,0.72)',
          },
          Button: { borderRadius: 10, controlHeight: 36 },
          Segmented: { borderRadius: 8 },
          Table: { headerBg: '#f8fafc', borderRadius: 12 },
        },
      }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename="/admin">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<DashboardPage />} />
                <Route path="/providers" element={<ProvidersPage />} />
                <Route path="/providers/:id" element={<ProviderDetailPage />} />
                <Route path="/model-groups" element={<ModelGroupsPage />} />
                <Route path="/workflows" element={<WorkflowsPage />} />
                <Route path="/workflows/:id" element={<WorkflowEditorPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/workers" element={<WorkersPage />} />
                <Route path="/queue" element={<QueuePage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/webhooks" element={<WebhooksPage />} />
                <Route path="/consumers" element={<ConsumersPage />} />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}
